export interface MonthProgress {
  day: number
  daysInMonth: number
  daysLeft: number
  /** Share of the month elapsed through today, 0–100 — the budget "pace" mark. */
  pacePercent: number
}

export function monthProgress(today: Date): MonthProgress {
  const day = today.getDate()
  const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
  return {
    day,
    daysInMonth,
    daysLeft: daysInMonth - day,
    pacePercent: (day / daysInMonth) * 100,
  }
}

export type BudgetStatus = 'over' | 'almost' | 'within'

// Same thresholds as the Budget page's bars: amber from 75%, red only above the limit.
export function budgetStatus(percentUsed: number): BudgetStatus {
  if (percentUsed > 100) return 'over'
  if (percentUsed >= 75) return 'almost'
  return 'within'
}
